/*
 * @Description:
 * @Author: mdb
 * @Date: 2023-03-04 10:17:51
 * @LastEditTime: 2023-04-10 13:36:01
 * @LastEditors: mdb
 */
import { defineStore } from 'pinia'
import { getLanguage } from '@/lang'

interface InteractionState {
  language: string
  subdomain: string
}

const getSubdomain = () => {
  return localStorage.getItem('subdomain') || 'cos_fbu'
}

export const useInteractionStore = defineStore({
  id: 'interaction',
  state: (): InteractionState => ({
    language: getLanguage(),
    subdomain: getSubdomain()
  }),
  actions: {
    setLanguage(language: string) {
      this.language = language
    },
    setSubdomain(subdomain: string) {
      this.subdomain = subdomain
      localStorage.setItem('subdomain', subdomain)
    }
  }
})
